import React, { useEffect, useState } from 'react';
import { Avatar, Box, Typography } from "@mui/material";
import PndRestApi from 'src/utils/pnd/PndRestApi';

const PndUserProfile = () => {
  useEffect(() => {
    if (localStorage.getItem('access_token')) {
      getProfileInformation();
    }

  }, []);
  const [profileName, setProfileName] = useState(null);
  const [designation, setDesgination] = useState(null);
  const [hubName, setHubName] = useState(null);

  const getProfileInformation = async () => {
    try {

      const response = await PndRestApi.GetProfileInformation();
      if (response.status === 200 && response.data.status === 200) {
        setProfileName(response?.data?.data?.fullName);
        localStorage.setItem('fullName', response?.data?.data?.fullName);
        setDesgination(response?.data?.data?.designation);
        setHubName(response?.data?.data?.hubName);
        if (response?.data?.data?.clientName) {
          localStorage.setItem('clientName', response?.data?.data?.clientName);
        }
        if (response?.data?.data?.subscriptionEndDateInDays) {
          localStorage.setItem('subscriptionEndDateInDays', response?.data?.data?.subscriptionEndDateInDays);
        }
      } else {
        console.error('Unexpected response status:', response.status);

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } 
  };
  return (
    <Box sx={styles.avatarContainer}>
      <Avatar sx={styles.avatar} alt='Profile Name'>
        {profileName?.charAt(0).toUpperCase()}
      </Avatar>
      <Typography variant="body2" sx={styles.profileText}>{profileName}</Typography>
      <Typography sx={{ fontFamily: 'ProductSansBold', fontSize: 13 }} variant="overline">{designation}</Typography>
      <Typography variant="overline">{hubName}</Typography>

    </Box>
  );
}

const styles = {
  avatarContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    my: 0.5, // margin y
    backgroundColor: '#F7F7F7',
    padding: '10px',
  },


  avatar: {
    cursor: 'pointer',
    width: '50px', // Set a fixed width for the Avatar
    height: '50px', // Set a fixed height for the Avatar
    backgroundColor: '#21B368', // Background color of the Avatar
    color: '#fff', // Text color of the Avatar
    fontFamily: 'ProductSansBold',
    borderRadius: '50%' // Makes the Avatar circular
  },
  profileText: {
    marginTop: '5px',
    fontSize: 20,
    color: '#0D1E1C',
    fontFamily: 'ProductSansBold'
  }
};

export default PndUserProfile;
